import {normalizeWorkspaceCapabilityCacheInput} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityCacheRevision";

function base64UrlEncodeUtf8(value: string): string {
    const bytes = new TextEncoder().encode(value);
    let binary = "";
    for (const byte of bytes) {
        binary += String.fromCharCode(byte);
    }

    return btoa(binary)
        .replaceAll("+", "-")
        .replaceAll("/", "_")
        .replace(/=+$/u, "");
}

export function buildPlutoCacheableGetUrl({
    input,
    path,
    intellsysBaseUrl,
}: {
    input: unknown;
    path: string;
    intellsysBaseUrl: string;
}): string {
    const prefixedPath = path.startsWith("/") === true ? `/sub-system/pluto${path}` : `/sub-system/pluto/${path}`;
    const url = new URL(prefixedPath, intellsysBaseUrl);
    url.searchParams.set("body", base64UrlEncodeUtf8(JSON.stringify(normalizeWorkspaceCapabilityCacheInput(input))));
    return url.toString();
}
